import { render } from "./BroadcastDisplayComponent.vue?vue&type=template&id=3254408e&scoped=true&ts=true"
import script from "./BroadcastDisplayComponent.vue?vue&type=script&lang=ts"
export * from "./BroadcastDisplayComponent.vue?vue&type=script&lang=ts"

import "./BroadcastDisplayComponent.vue?vue&type=style&index=0&id=3254408e&lang=scss"
import "./BroadcastDisplayComponent.vue?vue&type=style&index=1&id=3254408e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3254408e"]])

export default __exports__